// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ShareDataView__search-c7f26f {
  margin: 8px 24px;
  min-height: 40px;
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/components/ShareDataView/ShareDataView.styles.m.css"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,gBAAA;AACF","sourcesContent":[".search {\n  margin: 8px 24px;\n  min-height: 40px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"search": `ShareDataView__search-c7f26f`
};
module.exports = ___CSS_LOADER_EXPORT___;
